import { Solicitacao } from '@/models/Solicitacao';

import api from '@/sevices/api';

import { ProtocoloExecutado } from '@/models/ProtocoloExecutado';
import {
  RuntimeOptions,
  runtimePathPrefix,
} from '@/features/runtime/utils/helpers';
import { TipoItemComplementar } from '../models';

interface AddItemOptions {
  tipo: TipoItemComplementar;
  resource: fhir4.FhirResource;
  protocolo: ProtocoloExecutado;
}

interface UpdateItemOptions {
  id: string;
  tipo: TipoItemComplementar;
  resource: fhir4.FhirResource;
  opts?: RuntimeOptions;
}

async function create({
  tipo,
  resource,
  protocolo,
}: AddItemOptions): Promise<Solicitacao> {
  return (
    await api.post<Solicitacao>(
      `${runtimePathPrefix(protocolo)}/protocolos-executados/${
        protocolo.id
      }/solicitacoes/`,
      {
        tipo,
        incluir_bundle: false,
        pedido: resource,
      },
    )
  ).data;
}

async function destroy(
  itemID: string,
  opts: RuntimeOptions = {},
): Promise<void> {
  await api.delete(`${runtimePathPrefix(opts)}/solicitacoes/${itemID}/`);
}

async function update({
  id: itemID,
  tipo,
  resource,
  opts = {},
}: UpdateItemOptions): Promise<Solicitacao> {
  return (
    await api.put<Solicitacao>(
      `${runtimePathPrefix(opts)}/solicitacoes/${itemID}/`,
      {
        tipo,
        incluir_bundle: false,
        pedido: resource,
      },
    )
  ).data;
}

export default {
  create,
  destroy,
  update,
};
